export default __webpack_public_path__ + "static/media/sso-verification.e966ee0d.svg";